import { api } from '../../lib/api';
import type {
  Ga4BulkResult,
  Ga4ConnectionsResponse,
  Ga4DiscoverStartResponse,
  Ga4DiscoverStatusResponse,
} from '../../types/ga4Connections';

export const listGa4Connections = (): Promise<Ga4ConnectionsResponse> => api('/api/ga4-connections');

export const startGa4Discovery = (): Promise<Ga4DiscoverStartResponse> =>
  api('/api/ga4-connections/discover', { method: 'POST' });

export const getGa4DiscoveryStatus = (executionName: string): Promise<Ga4DiscoverStatusResponse> =>
  api(`/api/ga4-connections/discover/status?execution=${encodeURIComponent(executionName)}`);

export const connectGa4Property = (propertyId: string, accountId: string): Promise<{ ok: true }> =>
  api('/api/ga4-connections/connect', { method: 'POST', body: JSON.stringify({ propertyId, accountId }) });

/** ⚠️ Property ids only: the server pairs each with ITS OWN current suggestion. */
export const connectSuggestedGa4Properties = (propertyIds: string[]): Promise<Ga4BulkResult> =>
  api('/api/ga4-connections/connect-suggested', { method: 'POST', body: JSON.stringify({ propertyIds }) });

export const disconnectGa4Property = (accountId: string): Promise<{ ok: true }> =>
  api('/api/ga4-connections/disconnect', { method: 'POST', body: JSON.stringify({ accountId }) });
